import request from "@/plugins/axios/request";
/*
//定义接口
export function fetchList(query) {
  return request({
    url: '/article/list',
    method: 'get',
    params: query
  })
}

//使用接口
导入   import { fetchList } from '@/api/article'

使用
fetchList(this.listQuery).then(response => {
    this.list = response.data.items
    this.listLoading = false
}).catch(err => {

})
 */

export function login(ruleForm) {
    return request({
        url: "front/login",
        method: "post",
        data: ruleForm
    });
}

export function getInfo(token) {
    return request({
        url: "/user/info",
        method: "get",
        params: { token }
    });
}

export function logout() {
    return request({
        url: "/front/logout",
        method: "get"
    });
}
export function list() {
    return request({
        url: "page/api/category/1",
        method: "get"
    });
}
//获取登陆链接地址
export function getLoginUrl() {
    return request({
        url: "/front/getloginurl",
        method: "get"
    });
}
//获取用户信息
export function getUserInfo() {
    return request({
        url: "/front/getloginuser",
        method: "get"
    });
}
